import { NgClass } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NavigationItem } from 'types/navigation-item.interface';

@Component({
  selector: 'app-navigation-dropdown',
  standalone: true,
  imports: [TranslateModule, NgClass],
  templateUrl: './navigation-dropdown.component.html',
  styleUrl: './navigation-dropdown.component.scss'
})
export class NavigationDropdownComponent {
  @HostBinding('class.open') isOpen: boolean = false;
  @Input() addUserIcon: boolean = false;
  @Input() navigationItem!: NavigationItem;

  constructor(private router: Router) {}

  setIsOpen(isOpen: boolean): void {
    this.isOpen = isOpen;
  }

  navigate(url: string): void {
    this.router.navigate([url]);
  }

  handleArrowPress(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.isOpen = !this.isOpen;
    }
  }

  onBlur(event: FocusEvent): void {
    if (event.relatedTarget) {
      const relatedTarget = event.relatedTarget as Element;

      if (!relatedTarget.classList.contains('inner')) {
        this.isOpen = false;
      }
    }
  }

  public isActive(): boolean {
    const matchedChild = this.navigationItem.children?.find((child: NavigationItem) => this.router.url === child.url);

    if (this.navigationItem.highlightPaths) {
      return this.navigationItem?.highlightPaths.find((path: string) => this.router.url.includes(path)) !== undefined;
    }

    return this.router.url === this.navigationItem.url || !!matchedChild;
  }
}
